import React from 'react'
import { useSelector } from 'react-redux';

const TableCount = (props) => {
  const device = useSelector(state => state.CommonConfig.device_type);
  return (
    <>

      <span className="pagination-dropdown">
        <select
          id="rowsToShow"
          value={props.rowsToShow}
          onChange={props.handleRowsToShowChange}
          className='text-center'
        >
        {device === "Desktop" ? (
          <>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={30}>30</option>
          </>
        )
        :
        (
          <>
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={30}>30</option>
          </>
        )}
        </select>
      </span>
    </>
  )
}

export default TableCount
